var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentMapDoubleDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41925",
    "data-name": "Group 41925",
    transform: "translate(17404 -2462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15795",
    "data-name": "Rectangle 15795",
    width: 32,
    height: 32,
    transform: "translate(-17404 2462)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41920",
    "data-name": "Group 41920",
    transform: "translate(-141 -78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M101.152-484.214h-8.5v-2h8.5v2",
    transform: "translate(-17355.652 3045.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64-2",
    "data-name": "path64",
    d: "M101.152-484.214h-8.5v-2h8.5v2",
    transform: "translate(-17332.152 3045.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M453.518-681.808h-.5v-8h.5v8",
    transform: "translate(-17708.018 3240.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28-2",
    "data-name": "path28",
    d: "M453.518-681.808h-.5v-8h.5v8",
    transform: "translate(-17692.518 3240.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37117",
    "data-name": "Path 37117",
    d: "M-17238.984,2551c-8.1.782-8,8-8,8",
    transform: "translate(-0.016 0.001)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37118",
    "data-name": "Path 37118",
    d: "M-17246.984,2551c8.1.782,8,8,8,8",
    transform: "translate(-8.016 0.001)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentMapDoubleDoor);
export default __webpack_public_path__ + "static/media/agent-map-double-door.616bc6e1fc29f1c7121aa8fc850e90be.svg";
export { ForwardRef as ReactComponent };